export default __webpack_public_path__ + "static/media/BUY.76dabb64.png";